import { useCallback, useEffect, useState } from "react";
import LoaderModal from "../common/loader";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ListView } from "../../assets/svg/list_view_ic.svg";
import { ReactComponent as SelectGrid } from "../../assets/svg/seelct_grid_ic.svg";
import { ReactComponent as SelectList } from "../../assets/svg/select_list_ic.svg";
import { ReactComponent as EmailView } from "../../assets/svg/email_view_ic.svg";
import { ReactComponent as DownArrow } from "../../assets/svg/down_arror.svg";
import { Dropdown, Button, Modal, Form, Toast, ToastContainer } from "react-bootstrap";
import SearchableDropdown from "../common/commonDropDown";
import DateRangePicker from "../common/dateRange";
import { format } from "date-fns";
import profileIc from "../../assets/png/profile-ic.png";
import { ReactComponent as LoadingIc } from "../../assets/svg/loading_icon.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as RequestIc } from "../../assets/svg/request_ic.svg";
import { ReactComponent as ValidateIc } from "../../assets/svg/validat_ic.svg";
import ReactPaginate from "react-paginate";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import { ReactComponent as ThreeDotIC } from "../../assets/svg/three-dot-ic.svg";
import { getQuotationListApi } from "./purchase-quotation-api";
import { apiCall } from "../../services/api-service.js";
import { useGlobal } from "../../GlobalContext";
import ProfileImageModal from "../common/common-preview";
function PurchaseQuotationListPage() {
  // Api Url
  const apiUrl = process.env.REACT_APP_API_URL;
  // Main Decalration of state
  const navigate = useNavigate();

  // variable
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState("");
  const [active, setActive] = useState("list");
  const [vendorSelect, setVendorSelect] = useState(null);
  const [statusSelect, setStatusSelect] = useState({ value: "", label: "All Status" });
  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [quotationList, setQuotationList] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [selectedApprovalFilter, setSelectedApprovalFilter] = useState({
    value: "",
    label: "Show all",
  });
  const [pendingApprovalsCount, setPendingApprovalsCount] = useState(0);
  const [isApprovalDropdownOpen, setIsApprovalDropdownOpen] = useState(false);

  const [itemOffset, setItemOffset] = useState(0);
  const [selectedSortby, setSelectedSortBy] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });
  const sortByOption = [
    { value: "created asc", label: "Created (Oldest)" },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ];
  const [stageListOption, setListStageOption] = useState([
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
    { value: "Converted", label: "Converted" },
  ]);
  const iconStyle = { width: "16px", height: "16px" };

  // function
  const handleSelectVendor = (option) => {
    console.log("Selected option:", option);
    setVendorSelect(option);
  };

  const handleClearVendor = () => {
    setVendorSelect(null);
  };
  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);
  const handleDateChange = ({ start, end }) => {
    console.log("Selected Start:", start);
    console.log("Selected End:", end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    console.log("Formatted Start:", formattedStart);
    console.log("Formatted End:", formattedEnd);

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };

  //Api
  const getpurchaseList = useCallback(async () => {
    setIsLoading(true);

    const [field, dir] = selectedSortby?.value?.split(" ") || [
      "Created",
      "desc",
    ];

    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: search?.trim() || "", // ✅ avoid accidental spaces
      vendor_id: vendorSelect?.value ?? "",
      status: statusSelect?.value ?? "",
      from_date: startDateSave || null,
      to_date: endDateSave || null,
      sort_field: field,
      sort_dir: dir,
      my_approvals: selectedApprovalFilter?.value ?? "",
    };

    try {
      const response = await getQuotationListApi(param);
      if (response?.data?.success) {
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
        setQuotationList((Array.isArray(response.data.quotations) ? response.data.quotations : []).filter(Boolean));
        setPendingApprovalsCount(Number(response.data.pending_approvals_count) || 0);
      } else {
        console.warn("API returned success: false", response?.data);
        setQuotationList([]);
      }
    } catch (err) {
      console.error("Error fetching purchase list:", err);
    } finally {
      setIsLoading(false);
    }
  }, [
    itemsPerPage,
    itemOffset,
    search,
    selectedSortby,
    vendorSelect,
    statusSelect,
    startDateSave,
    endDateSave,
    selectedApprovalFilter,
  ]);
  const { rolePermissionList, userType } = useGlobal();
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true,
    ) > -1
      ? true
      : false;
  }
  useEffect(() => {
    getpurchaseList();
  }, [getpurchaseList]);
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [approvalAction, setApprovalAction] = useState("");
  const [approvalPoId, setApprovalPoId] = useState(null);
  const [approvalComments, setApprovalComments] = useState("");
  const [approvalCommentsMandatory, setApprovalCommentsMandatory] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const handleApprovalActionClick = (poId, action, isCommentsMandatory) => {
    setApprovalPoId(poId);
    setApprovalAction(action);
    setApprovalComments("");
    setApprovalCommentsMandatory(isCommentsMandatory || action === "REJECT");
    setShowApprovalModal(true);
  };

  const handleApprovalAction = async () => {
    if (approvalCommentsMandatory && !approvalComments.trim()) {
      alert("Comment is required.");
      return;
    }

    setShowApprovalModal(false);
    setIsLoading(true);
    try {
      const response = await apiCall("post", "approval/action", {
        document_id: approvalPoId,
        document_type: "purchase_quotation",
        action: approvalAction,
        comments: approvalComments,
      });
      if (response.data?.success) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(true);
        handleSnackbarShow();
        getpurchaseList();
      } else {
        setSnackbarMessage(response.data?.message || "Action failed");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (e) {
      console.error(e);
      setSnackbarMessage("An error occurred.");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <ProfileImageModal
        show={showProfilePopup}
        onClose={() => setShowProfilePopup(false)}
        imageUrl={selectedProfile}
      />{" "}
      <LoaderModal show={isLoading} />
      <style>
        {`
          .filter-btn-highlight {
            transition: all 0.2s ease-in-out !important;
            outline: none !important;
            box-shadow: none !important;
          }
          .filter-btn-highlight:hover {
            border-color: #d0d0d0 !important;
          }
          .filter-btn-highlight:focus, .filter-btn-highlight.show, .filter-btn-highlight:focus-within {
            border-color: #6c5ce7 !important;
            box-shadow: 0 0 0 0.2rem rgba(108, 92, 231, 0.15) !important;
          }
          .custom-dropdown-menu {
            border-radius: 8px !important;
            border: 1px solid #E2E8F0 !important;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
            padding: 8px 0 !important;
            margin-top: 4px !important;
          }
          .custom-dropdown-item {
            padding: 10px 20px !important;
            color: #1E293B !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            transition: all 0.2s ease;
          }
          .custom-dropdown-item:hover, .custom-dropdown-item:focus {
            background-color: #F1F5F9 !important;
            color: #1E293B !important;
          }
          .custom-dropdown-item.active {
            background-color: #F1F5F9 !important;
            color: #1E293B !important;
            font-weight: 600 !important;
          }
          #dropdown-approval-filter::after {
            display: none !important;
          }
          .my-approvals-toggle-btn {
            background-color: #F1F0FF !important;
            border: none !important;
            border-radius: 100px !important;
            padding: 8px 24px !important;
            height: 40px !important;
            color: #4F46E5 !important;
            transition: all 0.2s ease-in-out !important;
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 8px !important;
            box-shadow: none !important;
          }
          .my-approvals-toggle-btn:hover {
            background-color: #E8E6FF !important;
          }
          .my-approvals-toggle-btn:focus, .my-approvals-toggle-btn.show, .my-approvals-toggle-btn:focus-within {
            background-color: #E8E6FF !important;
            box-shadow: 0 0 0 0.2rem rgba(108, 92, 231, 0.15) !important;
          }
          .my-approvals-toggle-btn .dropdown-text {
            color: #4F46E5 !important;
            font-size: 14px !important;
            font-weight: 500 !important;
          }
          .view-toggle-container {
            height: 40px !important;
            background-color: #F1F3F6 !important;
            border-radius: 100px !important;
            padding: 4px !important;
            gap: 4px !important;
            align-items: center !important;
            justify-content: center !important;
            display: inline-flex !important;
          }
          .view-toggle-item {
            width: 32px !important;
            height: 32px !important;
            border-radius: 50% !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            cursor: pointer !important;
            transition: all 0.2s ease-in-out !important;
            border: none !important;
            background-color: transparent !important;
          }
          .view-toggle-item.active-item {
            background-color: #FFFFFF !important;
            box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08) !important;
            border: 0.8px solid #EBEBEB !important;
          }
        `}
      </style>
      <div className="d-flex">
        {" "}
        <Sidebar currentfile="Purchase Quotation" />
        <div className="rounded-4 flex-grow-1 bg-half-white">
          {" "}
          <Navbar pageTitle="Purchase Quotation" />
          <div className="bg-half-white p-2">
            <div className="bg-white rounded-4 p-4">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-3">
                {/* Left: Heading & Search */}
                <div className="d-flex align-items-center flex-wrap gap-3">
                  <div className="my-heading fs-24 fw-600">
                    Quotation - {totalCount}
                  </div>

                  <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2">
                    <SearchIc />
                    <input
                      type="text"
                      placeholder="Search"
                      className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor"
                      value={search || ""}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </div>

                {/* Right: Actions */}
                <div className="d-flex align-items-center flex-wrap gap-3">
                  {checkPermission(
                    "Purchase Quotation",
                    "create_permission",
                  ) && (
                    <div
                      className="cursor-pointer my-box d-flex align-items-center justify-content-center gap-2 px-3"
                      onClick={() => navigate("/pq/create")}
                      style={{
                        height: "40px", // Adjust button height if needed
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AddIc style={{ width: "16px", height: "16px" }} />{" "}
                      </div>

                      <div
                        className="fs-12 fw-600"
                        style={{ lineHeight: "16px" }}
                      >
                        New quotation
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                <div className="d-flex justify-content-start align-items-center gap-3 flex-wrap">
                  <div onClick={(e) => e.stopPropagation()}>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between filter-btn-highlight"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          padding: "6px 12px",
                          //   minWidth: "186px",
                          backgroundColor: "white",
                        }}
                        title={selectedSortby.label}
                      >
                        {/* Left: "Sort by" label */}
                        <span className="fs-12 fw-400 textGrey">Sort by :</span>

                        {/* Right: Selected + arrow */}
                        <span className="d-flex align-items-center px-1">
                          <span className="dropdown-text">
                            {selectedSortby.label}
                          </span>

                          <span className="dropdown-toggle-arrow textPurple">
                            <DownArrow />
                          </span>
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        className="custom-dropdown-menu"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        {sortByOption.map((option) => (
                          <Dropdown.Item
                            className="custom-dropdown-item"
                            key={option.value}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent parent onClick from firing
                              setSelectedSortBy(option); // Execute your selection logic
                            }}
                            active={selectedSortby.value === option.value}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}get_vendor`}
                      placeholder="Vendor"
                      value={vendorSelect}
                      onSelect={handleSelectVendor}
                      handleClear={handleClearVendor}
                    />
                  </div>
                  <div>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        className="d-flex align-items-center justify-content-between filter-btn-highlight"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          padding: "6px 12px",
                          backgroundColor: "white",
                          minWidth: "160px",
                          height: "40px"
                        }}
                      >
                        <span className="fs-12 fw-400 textGrey">Status :</span>
                        <span className="d-flex align-items-center px-1">
                          <span className="dropdown-text textcolor">
                            {statusSelect.label}
                          </span>
                          <span className="dropdown-toggle-arrow textPurple ps-1">
                            <DownArrow />
                          </span>
                        </span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        className="custom-dropdown-menu"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <Dropdown.Item
                            className="custom-dropdown-item"
                            onClick={(e) => {
                                e.stopPropagation();
                                setStatusSelect({ value: "", label: "All Status" });
                            }}
                            active={statusSelect.value === ""}
                        >
                            All Status
                        </Dropdown.Item>
                        {stageListOption.map((option) => (
                          <Dropdown.Item
                            className="custom-dropdown-item"
                            key={option.value}
                            onClick={(e) => {
                              e.stopPropagation();
                              setStatusSelect(option);
                            }}
                            active={statusSelect.value === option.value}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div
                    className="d-flex align-items-center px-1 filter-btn-highlight"
                    style={{
                      borderRadius: "12px",
                      border: "1px solid #EBEBEB",

                      backgroundColor: "white",
                    }}
                  >
                    <span className="fs-12 fw-400 textGrey">Date :</span>
                    <span
                      className="dropdown-text1 textPurple mb-2"
                      style={{ height: "28px" }}
                    >
                      {" "}
                      <DateRangePicker onChange={handleDateChange} />
                    </span>
                  </div>{" "}
                </div>
                <div className="d-flex align-items-center flex-wrap gap-3" style={{ marginLeft: "auto" }}>
                  <div onClick={(e) => e.stopPropagation()}>
                    <Dropdown onToggle={(isOpen) => setIsApprovalDropdownOpen(isOpen)}>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-approval-filter"
                        className="d-flex align-items-center justify-content-between filter-btn-highlight my-approvals-toggle-btn"
                      >
                        <span className="dropdown-text">
                          {selectedApprovalFilter.label}
                        </span>

                        {pendingApprovalsCount > 0 && !isApprovalDropdownOpen && (
                          <span
                            className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center"
                            style={{
                              fontSize: "10px",
                              width: "16px",
                              height: "16px",
                              fontWeight: "700",
                            }}
                          >
                            {pendingApprovalsCount}
                          </span>
                        )}

                        <span className="dropdown-toggle-arrow textPurple">
                          <DownArrow />
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        className="custom-dropdown-menu"
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        <Dropdown.Item
                          className="custom-dropdown-item"
                          onClick={() => {
                            setSelectedApprovalFilter({
                              value: "",
                              label: "Show all",
                            });
                            setItemOffset(0);
                          }}
                          active={selectedApprovalFilter.value === ""}
                        >
                          Show all
                        </Dropdown.Item>
                        <Dropdown.Item
                          className="custom-dropdown-item d-flex align-items-center justify-content-between"
                          onClick={() => {
                            setSelectedApprovalFilter({
                              value: "true",
                              label: "My approvals",
                            });
                            setItemOffset(0);
                          }}
                          active={selectedApprovalFilter.value === "true"}
                          style={{ gap: "10px" }}
                        >
                          <span>My approvals</span>
                          {pendingApprovalsCount > 0 && (
                            <span
                              className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center"
                              style={{
                                fontSize: "10px",
                                width: "16px",
                                height: "16px",
                                fontWeight: "700",
                              }}
                            >
                              {pendingApprovalsCount}
                            </span>
                          )}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="view-toggle-container">
                    <div
                      onClick={() => setActive("list")}
                      className={`view-toggle-item ${
                        active === "list" ? "active-item" : ""
                      }`}
                    >
                      {active === "list" ? (
                        <ListView style={iconStyle} />
                      ) : (
                        <SelectList style={iconStyle} />
                      )}
                    </div>

                    <div
                      onClick={() => setActive("grid")}
                      className={`view-toggle-item ${
                        active === "grid" ? "active-item" : ""
                      }`}
                    >
                      {active === "grid" ? (
                        <SelectGrid style={iconStyle} />
                      ) : (
                        <EmailView style={iconStyle} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {active === "list" && (
              <div className="bg-white rounded-4 mt-3 w-100 p-3 custom-scrollbar-x">
                <div style={{ minWidth: "1200px", width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      flex: "10",
                      paddingLeft: "16px",
                      paddingRight: "16px",
                      height: "44px",
                      backgroundColor: "#F2F2F2",
                    }}
                    className="head3 w-100 justify-content-center align-items-center"
                  >
                    <p style={{ flex: "1.4", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                      Quotation No
                    </p>
                    <p style={{ flex: "1.4", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                      Request No
                    </p>
                    <p style={{ flex: "1.8", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                      Vendor
                    </p>{" "}
                    <p style={{ flex: "1.2", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                      Validity Date
                    </p>{" "}
                    <p style={{ flex: "1.2", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                      Status
                    </p>{" "}
                    <p style={{ flex: "2.2", margin: "0px", whiteSpace: "nowrap" }} className="fs-13 fw-700 textcolor">
                      Next Approval
                    </p>{" "}
                    {/* <p
                      style={{ width: "160px", flex: "1.5" }}
                      className="fs-13 fw-700 textcolor"
                    >
                      Status
                    </p>{" "} */}
                  </div>
                  <div>
                    {quotationList && quotationList.length > 0 ? quotationList.map((item, index) => (
                      <div
                        style={{
                          display: "flex",
                          flex: "10",
                          paddingLeft: "16px",
                          paddingRight: "16px",
                          backgroundColor:
                            hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                          borderBottom: "1px solid #D4DDE7",
                          cursor: "pointer",
                          height: "44px",
                          position: "relative",
                        }}
                        onClick={() => {
                          if (
                            checkPermission(
                              "Purchase Quotation",
                              "view_permission",
                            )
                          ) {
                            navigate("/pq/view", {
                              state: { id: item.id },
                            });
                          }
                        }}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                        className="head3 w-100 justify-content-center align-items-center"
                      >
                        <p
                          className="fs-13 fw-500 textcolor"
                          style={{
                            flex: "1.4",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            margin: "0px",
                          }}
                          title={item.quotation_no}
                        >
                          {item.quotation_no ?? "---"}
                        </p>
                        <p
                          className="fs-13 fw-500 textcolor"
                          style={{
                            flex: "1.4",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            margin: "0px",
                        }}
                        title={item.req_no}
                      >
                        {item.req_no ?? "---"}
                      </p>

                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.8",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.vendor_name}
                      >
                        <img
                          key={index}
                          src={
                            item.image && item.image.trim() !== ""
                              ? item.image
                              : profileIc
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedProfile(
                              item.image && item.image.trim() !== ""
                                ? item.image
                                : profileIc,
                            );
                            setShowProfilePopup(true);
                          }}
                          alt="Profile"
                          className="avatar-item me-1 ms-0"
                        />
                        {item.vendor_name ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.2",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.validity_date}
                      >
                        {item.validity_date ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.2",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.status}
                      >
                        <span
                          className={`${
                            item.status?.toLowerCase() === "approved" || item.status?.toLowerCase() === "converted"
                              ? "backgroundGreen"
                              : item.status?.toLowerCase() === "rejected" || item.status?.toLowerCase() === "reject"
                              ? "backgroundRed"
                              : "backgroundYellow"
                          } me-2`}
                          style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "3px",
                            display: "inline-block",
                          }}
                        ></span>
                        {item.status ?? "---"}
                      </p>
                      <div
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "2.2",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          gap: "8px",
                          overflow: "visible",
                          minWidth: 0,
                        }}
                      >
                        {item.next_approver && item.next_approver !== "---" ? (
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "6px",
                              backgroundColor: "#F8F9FA",
                              borderRadius: "100px",
                              padding: "4px 12px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <LoadingIc style={{ width: "16px", height: "16px", flexShrink: 0 }} />
                            <span
                              className="text-truncate fs-13 fw-500"
                              style={{ 
                                maxWidth: (item.is_eligible && hoveredIndex === index) ? (item.can_reject ? "30px" : "55px") : "100px",
                                fontStyle: "italic",
                                color: "#1E293B"
                              }}
                              title={item.next_approver}
                            >
                              {item.next_approver}
                            </span>
                          </div>
                        ) : (
                          <span
                            className="text-truncate"
                            style={{ maxWidth: (item.is_eligible && hoveredIndex === index) ? (item.can_reject ? "30px" : "55px") : "100%" }}
                            title={item.next_approver}
                          >
                            {item.next_approver ?? "---"}
                          </span>
                        )}
                        {item.is_eligible && hoveredIndex === index && (
                          <>
                            <Button
                              variant="success"
                              className="rounded-5 fs-12 fw-600 py-0 px-2"
                              style={{
                                backgroundColor: "#10B981",
                                borderColor: "#10B981",
                                height: "28px",
                                lineHeight: "28px",
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleApprovalActionClick(item.id, "APPROVE", item.comments_mandatory);
                              }}
                            >
                              Approve
                            </Button>
                            {item.can_reject && (
                              <Button
                                variant="danger"
                                className="rounded-5 fs-12 fw-600 py-0 px-2 ms-1"
                                style={{
                                  backgroundColor: "#EF4444",
                                  borderColor: "#EF4444",
                                  height: "28px",
                                  lineHeight: "28px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleApprovalActionClick(item.id, "REJECT", true);
                                }}
                              >
                                Reject
                              </Button>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  )) : (
                    <div className="text-center p-4 w-100">
                      <span className="textGrey fs-14 fw-500">No Records Found</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
            {active === "grid" && (
              quotationList && quotationList.length > 0 ? (
                quotationList.map((vendor, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center justify-content-between flex-wrap business-card w-100 p-3 mt-3"
                  style={{ cursor: "pointer", height: "auto", minHeight: "84px" }}
                  onClick={() => {
                    if (
                      checkPermission("Purchase Quotation", "view_permission")
                    ) {
                      navigate("/pq/view", {
                        state: { id: vendor.id },
                      });
                    }
                  }}
                >
                  <div className="d-flex flex-grow-1" style={{ flex: "1 1 200px" }}>
                    <div className="profile-wrapper">
                      <img
                        src={
                          vendor.image && vendor.image.trim() !== ""
                            ? vendor.image
                            : profileIc
                        }
                        alt="Profile"
                        className="profile-img"
                      />
                    </div>
                    <div className="d-flex flex-column gap-2 ps-3">
                      <div className="textcolor fs-16 fw-400 ">
                        {vendor.vendor_name ?? "-"}
                      </div>
                      <div className="d-flex flex-row gap-2">
                        <div className="fs-12_5 fw-400 textGrey">
                          Quotation ID :
                        </div>
                        <div className="fs-12_5 fw-500 cardTextBlue">
                          {vendor.quotation_no ?? "-"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-2 ps-3 flex-grow-1" style={{ flex: "1 1 200px" }}>
                    <div className="d-flex flex-row gap-2">
                      <div className="d-flex align-items-center fs-12 fw-400 cardTextGrey">
                        <RequestIc
                          className="me-1"
                          style={{ width: "14px", height: "14px" }}
                        />
                        <span>Request :</span>
                      </div>

                      <div className="fs-13 fw-500 textcolor">
                        {vendor.req_no ?? "-"}
                      </div>
                    </div>
                    <div className="d-flex flex-row gap-2">
                      <div className="d-flex align-items-center fs-12 fw-400 cardTextGrey">
                        <ValidateIc
                          className="me-1"
                          style={{ width: "14px", height: "14px" }}
                        />
                        <span>Validity:</span>
                      </div>

                      <div className="fs-13 fw-500 textcolor">
                        {vendor.validity_date ?? "-"}
                      </div>
                    </div>
                  </div>
                  {
                    <div className="d-flex flex-row flex-grow-1 align-items-center justify-content-end gap-2 ps-3" style={{ flex: "1.2 1 300px" }}>
                      {vendor.next_approver && vendor.next_approver !== "---" && (
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                            backgroundColor: "#F8F9FA",
                            borderRadius: "100px",
                            padding: "4px 12px",
                            whiteSpace: "nowrap",
                            height: "36px",
                          }}
                        >
                          <LoadingIc style={{ width: "16px", height: "16px", flexShrink: 0 }} />
                          <span
                            className="text-truncate fs-13 fw-500"
                            style={{ 
                              maxWidth: "200px",
                              fontStyle: "italic",
                              color: "#8790A1"
                            }}
                            title={vendor.next_approver}
                          >
                            Waiting for <span style={{ color: "#1E293B", fontWeight: "600", fontStyle: "normal" }}>{vendor.next_approver}</span> approval
                          </span>
                        </div>
                      )}
                      <div className="d-flex flex-row align-items-center justify-content-end gap-2 ps-1">
                        <div onClick={(e) => e.stopPropagation()}>
                          {
                            <div
                              style={{
                                padding: "6px 12px",
                                height: "36px",
                                backgroundColor:
                                  vendor.status?.toLowerCase() === "approved" || vendor.status?.toLowerCase() === "converted"
                                    ? "#E5FFF0"
                                    : vendor.status?.toLowerCase() === "rejected" || vendor.status?.toLowerCase() === "reject"
                                    ? "#FEE2E2"
                                    : "#FFF5E2",
                              }}
                              className="d-flex align-items-center justify-content-between rounded-5"
                            >
                              <span className="d-flex align-items-center px-1 gap-2">
                                <span
                                  className={
                                    vendor.status?.toLowerCase() === "approved" || vendor.status?.toLowerCase() === "converted"
                                      ? "backgroundGreen"
                                      : vendor.status?.toLowerCase() === "rejected" || vendor.status?.toLowerCase() === "reject"
                                      ? "backgroundRed"
                                      : "backgroundYellow"
                                  }
                                  style={{
                                    width: "10px",
                                    height: "10px",
                                    borderRadius: "3px",
                                    display: "inline-block",
                                  }}
                                ></span>

                                <span className="dropdown-text textcolor fs-13 fw-500">
                                  {vendor.status ?? "-"}
                                </span>
                              </span>
                            </div>
                          }
                        </div>
                      </div>
                      {vendor.is_eligible && (
                        <div onClick={(e) => e.stopPropagation()}>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              id="dropdown-sort"
                              className="d-flex align-items-center justify-content-between  rounded-5 bg-white"
                              style={{
                                width: "36px",
                                height: "36px",
                                border: "1px solid #EBEBEB",
                              }}
                            >
                              <span className="d-flex align-items-center px-1 gap-2">
                                <ThreeDotIC />
                              </span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              style={{
                                backgroundColor: "white",
                                borderRadius: "8px",
                                border: "1px solid #EBEBEB",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              <Dropdown.Item
                                className="fs-14 fw-500"
                                style={{ color: "#10B981" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleApprovalActionClick(vendor.id, "APPROVE", vendor.comments_mandatory);
                                }}
                              >
                                Approve
                              </Dropdown.Item>
                              {vendor.can_reject && (
                                <Dropdown.Item
                                  className="fs-14 fw-500 text-danger"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleApprovalActionClick(vendor.id, "REJECT", true);
                                  }}
                                >
                                  Reject
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      )}
                      {!vendor.is_eligible && (
                        <div style={{ width: "36px", height: "36px" }}></div>
                      )}
                    </div>
                  }
                  </div>
                ))
              ) : (
                <div className="text-center p-4 w-100">
                  <span className="textGrey fs-14 fw-500">No Records Found</span>
                </div>
              )
            )}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">
                  Records per page: &nbsp;
                </span>
                <Dropdown.Toggle
                  id="dropdown-basic"
                  className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0"
                >
                  <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <DownArrowIc />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="my-2"
                  style={{ minWidth: "unset", width: "30%" }}
                >
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        setItemsPerPage(size);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate
                  previousLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <LarIc />
                    </div>
                  }
                  nextLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <RarIc />
                    </div>
                  }
                  breakLabel={"..."}
                  pageCount={pageCount + 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showApprovalModal}
        onHide={() => setShowApprovalModal(false)}
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-18 fw-600 textcolor">
            {approvalAction === "REJECT" ? "Reject Quotation" : "Approve Quotation"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-3">
          <Form.Group>
            <Form.Label className="fs-14 fw-500 textcolor mb-2">
              {approvalAction === "REJECT" 
                ? "Enter reason for rejection" 
                : "Enter comments"
              }
              {approvalCommentsMandatory && <span className="text-danger"> *</span>}
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={approvalComments}
              onChange={(e) => setApprovalComments(e.target.value)}
              placeholder="Type comments here..."
              className="fs-13 rounded-3"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button
            variant="light"
            onClick={() => setShowApprovalModal(false)}
            className="rounded-3 px-3 py-1_5 fs-13 fw-500"
          >
            Cancel
          </Button>
          <Button
            variant={approvalAction === "REJECT" ? "danger" : "primary"}
            onClick={handleApprovalAction}
            disabled={approvalCommentsMandatory && !approvalComments.trim()}
            className="rounded-3 px-3 py-1_5 fs-13 fw-500"
            style={approvalAction !== "REJECT" ? { backgroundColor: "#2563EB", borderColor: "#2563EB" } : {}}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}
export default PurchaseQuotationListPage;
